/* eslint-disable no-unused-vars */

import moment from 'moment';
import _ from 'lodash';

import InspectionSelector from './inspection/inspection.selector';

import { getDataPoints, getMoreInfoDataPoints } from '../pages/settings/helper';
import TasksSelector from './tasks/tasks.selector';
import { getTaskAssignedUserTags } from './tasks/helper';
import CheckSelector from './checks/check.selector';

const PipelineSelector = {
  getPipelineWithWO: async ({
    id = '',
    formWrapper = false,
    store,
    getWorkRequestData = false,
    createSiteDataPoints = false
  }) => {
    const {
      tasks,
      auth,
      settings,
      picklists,
      pipeline,
      inspection = {},
      checks = {},
      cache
    } = store;

    const { sites: cacheSites = [], sitesMap = {} } = cache;
    const { userId } = auth;

    let allWOTasks = [],
      allInspections = [],
      allChecks = [],
      allNewWorkRequestList = [],
      onDemandRecordList = [],
      allNewWorkOrderList = [],
      newChecksList = [],
      newInspectionList = [];

    if (id) {
      const [tasksResponse, inspectionsResponse, checksResponse] = !formWrapper
        ? await Promise.all([
            await TasksSelector.getTasks({ store }),
            await InspectionSelector.getInspections({ store }),
            await CheckSelector.getAllChecks({ store })
          ])
        : [[], [], []];

      allWOTasks = tasksResponse?.filter((task) =>
        task.newWorkOrder && task?.status !== 'To do'
          ? task?.responsible?.[0]?.woUserRequestId === userId
            ? true
            : false
          : task?.status === 'Synced'
          ? !task?.isNew
            ? true
            : false
          : !task.newWorkRequest
      );

      allInspections = inspectionsResponse;
      allChecks = checksResponse;

      allNewWorkRequestList = tasksResponse?.filter(
        (task) => task.newWorkRequest || task?.entityType === 'WorkRequest'
      );

      allNewWorkOrderList = tasksResponse?.filter((task) =>
        (task.newWorkOrder || task?.entityType === 'WorkOrder') &&
        task?.responsible?.[0]?.woUserRequestId !== userId &&
        task?.status !== 'To do' &&
        task?.status !== 'Synced'
          ? true
          : task?.status === 'Synced' && task?.isNew
          ? true
          : false
      );

      onDemandRecordList = [...allNewWorkOrderList, ...allNewWorkRequestList];
      // }
    } else {
      allWOTasks = tasks.tasksList?.filter((task) =>
        task.newWorkOrder && task?.status !== 'To do'
          ? task?.responsible?.[0]?.woUserRequestId === userId
            ? true
            : false
          : task?.status === 'Synced'
          ? !task?.isNew
            ? true
            : false
          : !task.newWorkRequest
      );

      allInspections = inspection?.inspectionsList;
      allChecks = checks?.checksList;

      allNewWorkOrderList = tasks.tasksList?.filter((task) =>
        (task.newWorkOrder || task?.entityType === 'WorkOrder') &&
        task?.responsible?.[0]?.woUserRequestId !== userId &&
        task?.status !== 'To do' &&
        task?.status !== 'Synced'
          ? true
          : task?.status === 'Synced' && task?.isNew
          ? true
          : false
      );

      allNewWorkRequestList = tasks.tasksList?.filter(
        (task) => task.newWorkRequest || task?.entityType === 'WorkRequest'
      );

      onDemandRecordList = [...allNewWorkOrderList, ...allNewWorkRequestList];
    }

    return new Promise((resolve) => {
      const { pipelineMobile = [] } = pipeline;
      const { workOrderUsersMap, workOrderUsersGroupsMap } = tasks;
      const userId = auth.userId || '';

      const { picklistsMap = {}, areaHierarchyTreeDataMap = {} } = picklists;

      const pipelineDisplayFields = settings.settings?.['pipelineDisplayFields'] || '';
      const pipelineHiddenDisplayFields = settings.hiddenDataPointsForAssets?.pipeline || '';

      const responsibleUsersMap = {
        ...(workOrderUsersMap || {}),
        ...(workOrderUsersGroupsMap || {})
      };

      const pipelines = id ? pipelineMobile?.filter((x) => x?.pipelineId === id) : pipelineMobile;

      const inspectionsAndWorkOrders = [...allWOTasks, ...allInspections, ...allChecks];

      let preparePipelines = [];

      pipelines?.map((pipeline) => {
        let allTasksAndInspectionsForPipeline = inspectionsAndWorkOrders.filter(
          (t) =>
            t.pipelineId === pipeline.pipelineId ||
            t?.relatedAssetId === pipeline.pipelineId ||
            t?.primaryAssetId === pipeline.pipelineId ||
            t?.pipelines?.includes(pipeline.pipelineId)
        );

        const allOnDemandRecordCount = onDemandRecordList?.filter(
          (t) =>
            t?.pipelineId === pipeline?.pipelineId ||
            t?.relatedAssetId === pipeline?.pipelineId ||
            t?.primaryAssetId === pipeline?.pipelineId ||
            t?.pipelines?.includes(pipeline?.pipelineId)
        );

        const workRequestList = allNewWorkRequestList?.filter(
          (t) =>
            t?.pipelineId === pipeline?.pipelineId ||
            t?.relatedAssetId === pipeline?.pipelineId ||
            t?.primaryAssetId === pipeline?.pipelineId ||
            t?.pipelines?.includes(pipeline?.pipelineId)
        );

        const newWorkOrdersList = allNewWorkOrderList?.filter(
          (t) =>
            t?.pipelineId === pipeline?.pipelineId ||
            t?.relatedAssetId === pipeline?.pipelineId ||
            t?.primaryAssetId === pipeline?.pipelineId ||
            t?.pipelines?.includes(pipeline?.pipelineId)
        );

        allTasksAndInspectionsForPipeline = allTasksAndInspectionsForPipeline.map((tas) => {
          const { responsibleUsers = [], responsibleUserGroups = [] } = tas;
          const customAssignedTaskValue = getTaskAssignedUserTags({
            responsibleUsers,
            responsibleUserGroups,
            workOrderUsersGroupsMap,
            userId,
            responsibleUsersMap
          });
          return {
            customAssignedTaskValue,
            ...tas
          };
        });

        const detailedData = PipelineSelector.getDetailedData(allTasksAndInspectionsForPipeline);

        const today = moment().format('YYYY-MM-DD');
        const allDoneTasks = allTasksAndInspectionsForPipeline.filter(
          (task) => task?.status === 'Synced'
        );
        const allotDoneTasks = allTasksAndInspectionsForPipeline.filter(
          (task) => task?.status !== 'Synced'
        );

        const isOverDue = allotDoneTasks.find((task) =>
          task.dueDate ? moment(task.dueDate).isBefore(today) : false
        );

        const dataPoints = getDataPoints(
          {
            ...pipeline,
            area: areaHierarchyTreeDataMap[pipeline?.area]?.title,
            type: pipeline?.pipelineTypeId || null,
            approvalNumber: pipeline?.approvalNumber || null
          },
          pipelineDisplayFields,
          'pipeline',
          picklistsMap
        );

        const dataPointsForSearch = pipelineHiddenDisplayFields
          ? getDataPoints(
              {
                ...pipeline,
                area: areaHierarchyTreeDataMap[pipeline?.area]?.title,
                type: pipeline?.pipelineTypeId || null,
                approvalNumber: pipeline?.approvalNumber || null
              },
              pipelineHiddenDisplayFields,
              'pipeline',
              picklistsMap
            )
          : [];

        const MoreInfoDataPoints = getMoreInfoDataPoints(
          {
            ...pipeline,
            area: areaHierarchyTreeDataMap[pipeline?.area]?.title,
            type: pipeline?.pipelineTypeId || null
          },
          'pipeline',
          picklistsMap
        );

        const MoreInfoDataPointsMap = MoreInfoDataPoints.reduce((acc, curr) => {
          acc[curr.Id] = curr;
          return acc;
        }, {});

        const status = picklistsMap[pipeline?.status]?.value || '';
        MoreInfoDataPointsMap['Status'] = { value: status, title: 'Status' };

        const siteIds = new Set([
          ...(pipeline?.fromSite ? [pipeline.fromSite] : []),
          ...(pipeline?.toSite ? [pipeline.toSite] : []),
          ...(pipeline?.sites?.map((x) => x.toLowerCase()) ?? []),
          ...(pipeline?.wells?.map((x) => x.toLowerCase()) ?? [])
        ]);

        const uniqueSiteIds = Array.from(siteIds);

        let dataPointsForSite = {},
          siteDataPointsForSearch = {};

        if (createSiteDataPoints) {
          for (let siteId of uniqueSiteIds) {
            const site = cacheSites[sitesMap[siteId]] || {};
            if (site) {
              const siteHiddenDisplayFields = settings.hiddenDataPointsForAssets?.site || '';
              const siteDisplayFields = settings.settings?.siteDisplayFields;

              dataPointsForSite = {
                ...dataPointsForSite,
                [siteId]: getDataPoints(
                  { ...site, type: site.siteType },
                  siteDisplayFields,
                  'site',
                  picklistsMap
                )
              };

              if (siteHiddenDisplayFields) {
                siteDataPointsForSearch = {
                  ...siteDataPointsForSearch,
                  [siteId]: getDataPoints(
                    { ...site, type: site?.siteType },
                    siteHiddenDisplayFields,
                    'site',
                    picklistsMap
                  )
                };
              }
            }
          }
        }

        preparePipelines.push({
          ...pipeline,
          title: `${pipeline?.licenseNumber}-${pipeline?.lineNumber}`,
          status: !formWrapper ? pipeline?.status : null,
          allDoneTasks,
          isOverDue,
          allTasksAndInspectionsForPipeline,
          allotDoneTasks,
          MoreInfoDataPointsMap,
          ...(id && detailedData),
          siteIds: uniqueSiteIds,

          dataPoints,
          dataPointsForSearch,
          soonestDueDate: _.min(
            allotDoneTasks.map((t) => t?.due || t?.dueDate).map((date) => new Date(date))
          ),
          newWorkRequestList: workRequestList,
          allOnDemandRecordCount: allOnDemandRecordCount?.length || 0,
          newWorkOrderList: newWorkOrdersList || [],
          newChecksList: [],
          newInspectionList: [],
          dataPointsForSite,
          siteDataPointsForSearch
        });
      });
      resolve(preparePipelines);
    });
  },

  getDetailedData: (allTasks) => {
    const today = moment().format('YYYY-MM-DD');

    const allWorkOrder = allTasks.filter((x) => x.type === 'Work Order');
    const allDoneWorkOrder = allWorkOrder.filter((x) => x.status === 'Synced');
    const allotDoneWorkOrder = allWorkOrder.filter((task) => task?.status !== 'Synced');

    const isWorkOrderOverDue = allotDoneWorkOrder.find((task) =>
      task.dueDate ? moment(task.dueDate).isBefore(today) : false
    );

    const allInspections = allTasks.filter((x) => x.type === 'Inspection');
    const allDoneInspection = allInspections.filter((x) => x.status === 'Synced');
    const allotDoneInspection = allInspections.filter((x) => x.status !== 'Synced');

    const isInspectionOverDue = allotDoneInspection.find((task) =>
      task.dueDate ? moment(task.dueDate).isBefore(today) : false
    );

    const allChecks = allTasks.filter((x) => x.type === 'Check');
    const allDoneCheck = allChecks.filter((x) => x.status === 'Synced');
    const allNotDoneCheck = allChecks.filter((x) => x.status !== 'Synced');

    const isCheckOverDue = allNotDoneCheck.find((task) =>
      task.nextDue ? moment(task.nextDue).isBefore(today) : false
    );

    return {
      allWorkOrder,
      allDoneWorkOrder,
      isWorkOrderOverDue,
      allInspections,
      allDoneInspection,
      isInspectionOverDue,
      allChecks,
      allDoneCheck,
      isCheckOverDue
    };
  }
};

export default PipelineSelector;
